import React from 'react';
import { Outlet } from 'react-router-dom';

function Root() {
  return (
    <div data-testid="root">
      <Outlet />
    </div>
  );
}

export default Root;
